import { pb } from '@/libs/pocketbase'
import type { UserProfilePort } from '../domain/auth'

const httpUserProfileAdapter: UserProfilePort = {
	async updateName(userId: string, name: string): Promise<void> {
		await pb.collection('users').update(userId, { name })
	},

	async setupOrg(companyName: string): Promise<void> {
		await pb.send('/api/auth/onboarding', {
			method: 'POST',
			body: JSON.stringify({ companyName }),
			headers: { 'Content-Type': 'application/json' },
		})
	},
}

export { httpUserProfileAdapter }
